import { BetStatus } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betStatusDictionary = createSimpleDictionary([
    { id: BetStatus.Running, name: 'dictionaries.betStatus.running', code: 'RUN' },
    { id: BetStatus.Waiting, name: 'dictionaries.betStatus.waiting', code: 'WAIT' },
    { id: BetStatus.Settled, name: 'dictionaries.betStatus.settled', code: 'SET' },
    { id: BetStatus.Rejected, name: 'dictionaries.betStatus.rejected', code: 'REJ' },
    { id: BetStatus.Refunded, name: 'dictionaries.betStatus.refunded', code: 'REF' },
    { id: BetStatus.Void, name: 'dictionaries.betStatus.void', code: 'VOID' },
    { id: BetStatus.Abnormal, name: 'dictionaries.betStatus.abnormal', code: 'ABN' },
]);
